// generated from 13_051 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const workflowStepRetargetFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("workflow_step_retarget_filter"),
  comparison_key: z.enum([
    "7", // 7_496 (57.44%)
    "8", // 5_555 (42.56%)
  ]),
  // null: 5 (0.04%)
  display_name: z
    .enum([
      "opened email", // 6_131 (47.00%)
      "clicked email", // 2_426 (18.60%)
      "directly opened push notification", // 1_877 (14.39%)
      "clicked in-app message", // 543 (4.16%)
      "opened email (other opens)", // 514 (3.94%)
      "clicked in-app message button 1", // 326 (2.50%)
      "clicked content card", // 270 (2.07%)
      "viewed in-app message", // 235 (1.80%)
      "dismissed content card", // 146 (1.12%)
      "viewed content card", // 144 (1.10%)
      "clicked shortened sms link", // 140 (1.07%)
      "clicked in-app message button 2", // 113 (0.87%)
      "clicked push notification button", // 48 (0.37%)
      "read WhatsApp message", // 48 (0.37%)
      "clicked tracked WhatsApp link", // 36 (0.28%)
      "clicked push story page", // 30 (0.23%)
      "opened email (machine opens)", // 12 (0.09%)
      "replied to sms", // 7 (0.05%)
      // Not sampled, but offered by CampaignRetargetFilter.allowed_interactions (inherited)
      // (feature flipper dependent; names from TRIGGER_ONLY_PAST_TENSE_DISPLAY_NAME_BY_INTERACTION).
      "viewed banner",
      "clicked banner",
      "dismissed banner",
      "clicked tracked LINE link",
      "clicked tracked KakaoTalk link",
    ])
    .nullable(),
  // undefined: 13_050 (99.99%), defined 1 (0.01%)
  has_hard_deleted_data: z.literal(true).optional(),
  // undefined: 4_297 (32.92%), defined 8_754 (67.08%)
  raw_value: z
    .union([
      // string samples: 8_747 (99.92%)
      // format object-id: 8_683 (99.27%)
      z.string(),
      // object samples: 7 (0.08%)
      z.object({
        campaign_id: common.objectId,
        sms_keyword_id: common.objectId,
      }),
    ])
    .optional(),
  value: z.object({
    id: z.union([
      // string samples: 13_044 (99.95%)
      // format object-id: 12_966 (99.40%)
      z.string(),
      // object samples: 7 (0.05%)
      z.object({
        campaign_id: common.objectId,
        sms_keyword_id: common.objectId,
      }),
    ]),
    // undefined: 1 (0.01%), defined 13_050 (99.99%)
    pre_filter_value: z
      .object({
        // true 4_198 (32.17%), false 8_852 (67.83%)
        expired: z.boolean(),
        id: common.objectId,
        value: z.string(),
      })
      .optional(),
    value: z.string(),
  }),
  varies_by_app_group: z.literal(true),
});
